import { render, staticRenderFns } from "./bzRead.vue?vue&type=template&id=ced03f50&scoped=true&"
import script from "./bzRead.vue?vue&type=script&lang=js&"
export * from "./bzRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced03f50",
  null
  
)

export default component.exports